import { render, staticRenderFns } from "./ProjectChangeOrders.vue?vue&type=template&id=4e07a140"
import script from "./ProjectChangeOrders.vue?vue&type=script&lang=js"
export * from "./ProjectChangeOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports